import React, {useEffect} from 'react';
import {getMessage} from '../utils/messages';
import {MonthlyProjectTimeForm, type MonthlyEntryFormValues} from './MonthlyProjectTimeForm';
import type {Config, ProjectTimeRecord} from '../types/types';

type EditMonthlyProjectTimeProps = {
	config: Config;
	maxDurationMs: number;
	record: ProjectTimeRecord | null;
	canEditDuration: boolean;
	disabled?: boolean;
	isOpen: boolean;
	onSubmit: (values: MonthlyEntryFormValues) => Promise<void>;
	onCancel: () => void;
	onDelete?: () => Promise<void>;
};

export const EditMonthlyProjectTime: React.FC<EditMonthlyProjectTimeProps> = ({
																				  config,
																				  maxDurationMs,
																				  record,
																				  canEditDuration,
																				  disabled,
																				  isOpen,
																				  onSubmit,
																				  onCancel,
																				  onDelete,
																			  }) => {
	useEffect(() => {
		if (!isOpen) {
			return;
		}
		const body = document.body;
		if (!body) {
			return;
		}
		body.classList.add('modal-open');
		return () => {
			body.classList.remove('modal-open');
		};
	}, [isOpen]);

	const isDisabled = Boolean(disabled);
	const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (event.target === event.currentTarget && !isDisabled) {
			onCancel();
		}
	};

	const formId = 'monthly-project-time-edit-form';

	if (!isOpen) {
		return null;
	}

	return (
		<>
			<div
				className="modal fade in"
				style={{display: 'block'}}
				role="dialog"
				aria-modal="true"
				onClick={handleBackdropClick}
			>
				<div className="modal-dialog modal-lg" role="document" onClick={event => event.stopPropagation()}>
					<div className="modal-content record-dialog">
						<div className="modal-header">
							<button
								type="button"
								className="close"
								aria-label={getMessage('dialog.close')}
								onClick={onCancel}
								disabled={isDisabled}
							>
								<span aria-hidden="true">&times;</span>
							</button>
							<h5 className="modal-title">{getMessage('record.header.edit')}</h5>
						</div>
						<div className="modal-body">
							<MonthlyProjectTimeForm
								config={config}
								maxDurationMs={maxDurationMs}
								record={record ?? undefined}
								canEditDuration={canEditDuration}
								disabled={isDisabled}
								formId={formId}
								onSubmit={onSubmit}
							/>
						</div>
						<div className="modal-footer clearfix">
							<div className="pull-left">
								{onDelete && (
									<button
										type="button"
										className="btn btn-outline-danger deleteButton"
										onClick={() => void onDelete()}
										disabled={isDisabled}
									>
										{getMessage('confirmation.delete')}
									</button>
								)}
							</div>
							<div className="pull-right">
								<button
									type="submit"
									className="btn btn-primary saveButton"
									disabled={isDisabled}
									form={formId}
								>
									{getMessage('dialog.save')}
								</button>
								<button
									type="button"
									className="btn btn-default cancelButton"
									onClick={onCancel}
									disabled={isDisabled}
								>
									{getMessage('confirmation.cancel')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade in"></div>
		</>
	);
};
